export default "images/Untitled design (5).png";